import { createSlice } from '@reduxjs/toolkit';
import { getFeaturedArticlesAll } from '../actions/featuredArticlesActions';
import { initBlogListType, blogListDefaultCases } from '../../blogs/slices/lists/blogListReducerUtils';

const initialState = initBlogListType() as BlogListStateType;

const articleFeaturedAllSlice = createSlice({
  name: 'articleFeaturedAllSlice',
  initialState,
  reducers: {},
  extraReducers: builder => {
    blogListDefaultCases(builder, getFeaturedArticlesAll);
  },
});

export default articleFeaturedAllSlice.reducer;
